/**
 * How a href turns into Action props.
 *
 * Both nav lists used to carry a hand-set `external: true` flag alongside the
 * url, and the flag and the url disagreed: the Resources dropdown's "API
 * Reference" pointed at https://docs.statio.dev/docs/api with no flag and no
 * `route`, so it fell through to `navigate(href)` and react-router turned an
 * absolute url into the route `/https://docs.statio.dev/docs/api`. The item was
 * broken in production and no flag audit would have found it, because the flag
 * was not the source of truth.
 *
 * The scheme is. An off-site link is one with a scheme, always, and there is no
 * way to write one that forgets to say so.
 */
export interface LinkProps {
  to?: string;
  href?: string;
  external?: boolean;
}

export function linkProps(href: string, route?: boolean): LinkProps {
  if (/^(https?:|mailto:)/.test(href)) return { href, external: true };
  // `/#id` stays an anchor so the fragment is in the url and copyable; every
  // other in-app path is a router Link.
  if (!route && href.startsWith('/#')) return { href };
  return { to: href };
}
